import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AssignmentDialogComponent } from '../../assignments/assignment-dialog/assignment-dialog.component';
import { TransferAssignmentComponent } from '../../assignments/transfer-assignment/transfer-assignment.component';
import {AssignmentService} from '../services/assignment.service';
import { IWGSharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentDialogService {

  constructor(private dialog: MatDialog, private assignmentService: AssignmentService,
              private sharedService: IWGSharedService) { }


  show(ev= null, existingAssignmentId= null, quoteId= null, managerId= null, workerId= null, serviceId= null, isTransferToAOR= null, isExistingTransferAssignment= null, isEditFromDetails= null){
    if (existingAssignmentId) {
      const dialogRef = this.showDialogWithManagerAndWorker(ev, null, quoteId, managerId, workerId, serviceId, isTransferToAOR, isExistingTransferAssignment, isEditFromDetails, true);
      dialogRef.componentInstance.isLoading = true;
      this.assignmentService.getAssignmentById(existingAssignmentId).subscribe(
          data => {
            dialogRef.componentInstance.existingAssignment = data.data.Data;
            dialogRef.componentInstance.isLoading = false;
            dialogRef.componentInstance.initData();
          },
          err => {
            console.log(err);
          }
        );
    } else {
        this.showDialogWithManagerAndWorker(ev, null, quoteId, managerId, workerId, serviceId, isTransferToAOR, isExistingTransferAssignment, isEditFromDetails);
    }
  }

  showDialog(ev= null, assignment= null, quoteId= null) {
    this.showDialogWithManagerAndWorker(ev, assignment, quoteId, null, null, null, false, false, false);
  }

  showDialogWithManagerAndWorker(ev= null, assignment= null, quoteId= null, managerId= null, workerId= null, serviceId= null, isTransferToAOR= null, isExistingTransferAssignment= null, isEditFromDetails= null, fetchInProgress = false){
      // this.sharedService.isDialogOpen.next(true);
      this.sharedService.isBlurredBg.next(true);

      const dialogRef = this.dialog.open(AssignmentDialogComponent, {
        panelClass: ['iwg-form-dialogfull'], maxWidth: '100%',
        autoFocus: false,
        data : {
          quoteId,
          managerId,
          workerId,
          serviceId,
          existingAssignment: assignment,
          isExistingTransferAssignment,
          isEditFromDetails,
          isTransferToAOR,
          fetchInProgress
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.sharedService.isBlurredBg.next(false);
      });
      return dialogRef;
  }
}
